
<section id="jointhrift">

  <!-- <section class="no-padding-top">
    <div class="container-fluid">
      <div class="row">  -->
  <div id="joinThrift" tabindex="-1" data-backdrop="static" data-keyboard="false"  role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true" class="modal fade text-left">
    <div role="document" class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header"><strong id="exampleModalLabel" class="modal-title">JOIN A THRIFT</strong>
          <button type="button" data-dismiss="modal" (click)="cancelModal()" aria-label="Close" class="close"><span  aria-hidden="true">×</span></button>
        </div>
        <div class="modal-body">
          <p>To join a thrift Paste the thrift Invitation code below. Inserting an Invalid Invitation code will definetly not work. <br>Do well to read the thrift terms and conditions before joining any thrift.</p>
          
          <!-- Form Section to join thrift -->

          <section class="no-padding-top">
            <div class="container-fluid">
              <div class="row">

                <div class="col-lg-12">                           
                  <div class="block">
                    <!-- <div class="title"><strong>Inline Form</strong></div> -->
                    <div class="block-body">
                      <form [formGroup]="joinThrift" (ngSubmit)="getThrift()" class="form-inline">
                        <div class="form-group">
                          <label for="inlineFormInput" class="sr-only">Name</label>
                          <input id="inlineFormInput"
                          formControlName="thrift_id"
                          name="thrift_id" 
                           type="text"
                           *ngIf="!finalJoin" 
                           placeholder="Paste Thrift Code" class="mr-sm-3 form-control">

                           <input id="inlineFormInput"
                          formControlName="thrift_id"
                          name="thrift_id" 
                           type="text"
                           readonly 
                           *ngIf="finalJoin"
                           placeholder="Paste Thrift Code" class="mr-sm-3 form-control">
                        </div>
                        <!-- ISA24495 -->
                        <div class="form-group">
                          <input type="submit" *ngIf="!finalJoin" [disabled]="joinThrift.invalid" value="Proceed" class="btn btn-primary">
                          <div *ngIf="thriftType != 'personalThrift'">
                            <input type="submit" *ngIf="finalJoin" (click)="joinThrifts()" value="Confirm" data-dismiss="modal" class="btn btn-primary">
                          </div>
                         
                        </div>
                        <span  style="color: red; font-size: 12px;"> {{thriftMessage}} </span>
                      </form>
                    </div>
                  </div>
                </div>
                </div>
                </div>
                </section>

                <!-- Thrift Details -->
                
                
                <section *ngIf="finalJoin"  class="no-padding-bottom">
                  <section *ngIf="thriftType == 'Organization Thrift'">
                    <p >Description:  <span class="p-2 "  style="word-wrap: break-word; border-radius: 5px 5px; background-color: rgb(20, 171, 20); color: #fff;"> {{thriftDetails?.description}} </span></p>
                    <p >Thrift Name:  <span class="p-2 "  style="word-wrap: break-word; border-radius: 5px 5px; background-color: rgb(20, 171, 20); color: #fff;"> {{thriftDetails?.thriftName}} </span></p>
                    <p >Thrift Creator:  <span class="p-2 "  style="word-wrap: break-word; border-radius: 5px 5px; background-color: rgb(20, 171, 20); color: #fff;"> {{userDetails?.firstname}} {{userDetails?.lastname}} </span></p>
                    <p >Amount:  <span class="p-2 "  style="word-wrap: break-word; border-radius: 5px 5px; background-color: rgb(20, 171, 20); color: #fff;"> {{thriftDetails?.amount}} </span></p>
                    <p >Attainable Amount:  <span class="p-2 "  style="word-wrap: break-word; border-radius: 5px 5px; background-color: rgb(20, 171, 20); color: #fff;"> {{thriftDetails?.attainableAmount}} </span></p>
                    <p >Start Date:  <span class="p-2 "  style="word-wrap: break-word; border-radius: 5px 5px; background-color: rgb(20, 171, 20); color: #fff;"> {{thriftDetails?.startDate}} </span></p>
                    <p >End Date:  <span class="p-2 "  style="word-wrap: break-word; border-radius: 5px 5px; background-color: rgb(20, 171, 20); color: #fff;"> {{thriftDetails?.endDate}} </span></p>
                    <p >Number of Participants:  <span class="p-2 "  style="word-wrap: break-word; border-radius: 5px 5px; background-color: rgb(20, 171, 20); color: #fff;"> {{thriftDetails?.noOfPeople}} </span></p>
                    <p >Date Created:  <span class="p-2 "  style="word-wrap: break-word; border-radius: 5px 5px; background-color: rgb(20, 171, 20); color: #fff;"> {{thriftDetails?.datecreated}} </span></p>
                  </section>


                  <section *ngIf="thriftType == 'domesticThrift'">
                    <p >Description:  <span class="p-2 "  style="word-wrap: break-word; border-radius: 5px 5px; background-color: rgb(20, 171, 20); color: #fff;"> {{thriftDetails?.description}} </span></p>
                    <p >Thrift Name:  <span class="p-2 "  style="word-wrap: break-word; border-radius: 5px 5px; background-color: rgb(20, 171, 20); color: #fff;"> {{thriftDetails?.thriftName}} </span></p>
                    <p >Thrift Creator:  <span class="p-2 "  style="word-wrap: break-word; border-radius: 5px 5px; background-color: rgb(20, 171, 20); color: #fff;"> {{userDetails?.firstname}} {{userDetails?.lastname}} </span></p>
                    <p >Amount:  <span class="p-2 "  style="word-wrap: break-word; border-radius: 5px 5px; background-color: rgb(20, 171, 20); color: #fff;"> {{thriftDetails?.amount}} </span></p>
                    <p >Attainable Amount:  <span class="p-2 "  style="word-wrap: break-word; border-radius: 5px 5px; background-color: rgb(20, 171, 20); color: #fff;"> {{thriftDetails?.attainableAmount}} </span></p>
                    <p >Start Date:  <span class="p-2 "  style="word-wrap: break-word; border-radius: 5px 5px; background-color: rgb(20, 171, 20); color: #fff;"> {{thriftDetails?.startDate}} </span></p>
                    <p >End Date:  <span class="p-2 "  style="word-wrap: break-word; border-radius: 5px 5px; background-color: rgb(20, 171, 20); color: #fff;"> {{thriftDetails?.endDate}} </span></p>
                    <p >Number of Participants:  <span class="p-2 "  style="word-wrap: break-word; border-radius: 5px 5px; background-color: rgb(20, 171, 20); color: #fff;"> {{thriftDetails?.noOfPeople}} </span></p>
                    <p >Date Created:  <span class="p-2 "  style="word-wrap: break-word; border-radius: 5px 5px; background-color: rgb(20, 171, 20); color: #fff;"> {{thriftDetails?.datecreated}} </span></p>
                  </section>

                  <section *ngIf="thriftType == 'personalThrift'">
                    <p >Type Of Thrift:  <span class="p-2 "  style="word-wrap: break-word; border-radius: 5px 5px; background-color: rgb(20, 171, 20); color: #fff;">  Personal Thrift  </span></p>
                    <p >Info:  <span class="p-2 "  style="word-wrap: break-word; border-radius: 5px 5px; background-color: rgb(233, 194, 67); color: #fff; text-transform: uppercase;">  Sorry you cannot Join  </span></p>
                  </section>
                  
                  </section>
        </div>
        <div class="modal-footer">
            <small style="color: red;">Thrively will not be held liable to loss of funds due to user carelessness or negligence.</small>
        </div>
      </div>
    </div>
  </div>
<!-- </div>
</div>
</section> -->
</section>